// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1786d07a","508":"adb81b9c","821":"8de04e5a"}[chunkId] + ".chunk.js";
};